import { FC, useMemo } from 'react'
import { useListView } from '../../core/ListViewProvider'
import { IAvaliacoesSelect } from '../../core/_models'

type Props = IAvaliacoesSelect & {
  /** Nome acessível do checkbox (ex.: "Selecionar avaliação de Maria"). */
  ariaLabel?: string
}

/** Seleção por par atendimento + formulário (a assinatura em lote precisa dos dois ids). */
export const AvaliacoesPendentesSelectionCell: FC<Props> = ({
  atendimentoId,
  formularioAtendimentoId,
  ariaLabel,
}) => {
  const { selected, onSelect } = useListView()
  const isSelected = useMemo(
    () =>
      selected.some(
        (item: IAvaliacoesSelect) =>
          item.atendimentoId === atendimentoId &&
          item.formularioAtendimentoId === formularioAtendimentoId
      ),
    [selected, atendimentoId, formularioAtendimentoId]
  )

  return (
    <div className='form-check form-check-sm form-check-custom form-check-solid'>
      <input
        className='form-check-input'
        type='checkbox'
        checked={isSelected}
        aria-label={ariaLabel}
        onChange={() => onSelect({ atendimentoId, formularioAtendimentoId })}
      />
    </div>
  )
}
